import { PiInfoFill } from "react-icons/pi";
import { useState, } from "react";
import { Popover, ArrowContainer } from 'react-tiny-popover'



export function InfoTooltip({ id, text, rest }) {
  const [open, setOpen] = useState(false);
  // const handleOpen = () => {
  //   setOpen(true);
  // }
  // const handleClose = () => {
  //   setOpen(false)
  // }

  return (
    <>
      <Popover
        isOpen={open}
        positions={['top']}
        parentElement={id?.current}
        content={({ position, childRect, popoverRect }) => (
          <ArrowContainer 
            position={position}
            childRect={childRect}
            popoverRect={popoverRect}
            arrowColor={'white'}
            arrowSize={10}
            arrowStyle={{ opacity: 1 }}
            className='popover-arrow-container'
            arrowClassName='popover-arrow'
          >
              {text}
          </ArrowContainer>
        )}
      >
        <div onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
          <PiInfoFill className="text-gray-500" {...rest} />
        </div>
      </Popover>
    </>
  );
}
